(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stargate-product-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sg-pdp').forEach((section) => {
    const select = section.querySelector('[data-sg-variant-select]');
    const price = section.querySelector('[data-sg-price]');
    const button = section.querySelector('[data-sg-add]');
    if (!select || !price || !button) return;

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      const variantPrice = option.dataset.price || '';
      const label = available ? button.dataset.addLabel : button.dataset.soldLabel;
      price.textContent = variantPrice;
      button.disabled = !available;
      button.textContent = available ? label + ' — ' + variantPrice : label;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);

      const mediaId = option.dataset.mediaId;
      if (mediaId && window.matchMedia('(max-width: 989px)').matches) {
        section.querySelector('[data-media-id="' + mediaId + '"]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    select.addEventListener('change', updateVariant);
  });

  } catch(e) { console.error(e); }
})();
})();
